/** Adjusts the layout of the product page based on the screen size. */
export class ProductPageLayoutAdjustments {
	/** The body content of the description that can be hidden. */
	descriptionBody: HTMLDivElement;

	/** The header of the description that can be hidden. */
	descriptionHeader: HTMLDivElement;

	/** The details area that will be moved around. */
	detailsArea: HTMLDivElement;

	/** Whether the page is in mobile view. */
	layoutIsMobile: boolean;

	/** The left pane of the screen on desktop. Top on mobile. */
	leftPane: HTMLDivElement;

	/** The right side of the screen, bottom on mobile. */
	rightPane: HTMLDivElement;

	constructor() {
		this.leftPane = document.querySelector(".rt-pspr-left") as HTMLDivElement;
		this.rightPane = document.querySelector(".rt-pspr-right") as HTMLDivElement;
		this.detailsArea = document.querySelector(
			".rt-pspr-description",
		) as HTMLDivElement;
		this.descriptionBody = document.querySelector(
			".rt-accordion-body",
		) as HTMLDivElement;
		this.descriptionHeader = document.querySelector(
			".rt-accordion-button",
		) as HTMLDivElement;

		if (
			!this.leftPane ||
			!this.rightPane ||
			!this.detailsArea ||
			!this.descriptionBody ||
			!this.descriptionHeader
		)
			throw new Error("Missing Product Page Element");

		this.layoutIsMobile = false;

		if (this.screenIsMobile()) this.switchToMobile();
		this.initDescriptionToggle();
		window.addEventListener("resize", () => {
			this.handleChange();
		});
	}

	/** Handles window resize. */
	handleChange(): void {
		if (!this.screenIsMobile() && this.layoutIsMobile) {
			this.switchToDesktop();
		} else if (this.screenIsMobile() && !this.layoutIsMobile) {
			this.switchToMobile();
		}
	}

	/** Adds listeners and initial state to the collapsing description area. */
	initDescriptionToggle(): void {
		const { descriptionBody } = this;

		if (this.screenIsMobile()) {
			descriptionBody.classList.add("rt-accordion-collapsed");
		}
	}

	/**
	 * If the width of the screen is currently below the threshold for mobile.
	 *
	 * @returns True if the width of the screen is currently below the threshold
	 *   for mobile.
	 */
	screenIsMobile(): boolean {
		return window.innerWidth <= 869;
	}

	/** Move the description to the left area of the page. */
	switchToDesktop(): void {
		this.layoutIsMobile = false;
		this.rightPane.removeChild(this.detailsArea);
		this.leftPane.appendChild(this.detailsArea);
	}

	/** Move the description area to the bottom of the page. */
	switchToMobile(): void {
		this.layoutIsMobile = true;
		this.leftPane.removeChild(this.detailsArea);
		this.rightPane.appendChild(this.detailsArea);
	}
}
